import React from "react";
import { TrendingUp as TrendingUpIcon } from "@mui/icons-material";
import { Box as MuiBox } from "@mui/material";
import PropTypes from "prop-types";

const SectionIcon = ({ icon, color }) => {
  const Icon = icon || TrendingUpIcon;
  return (
    <MuiBox
      sx={{
        border: "1px solid #DDD",
        borderRadius: "50%",
        width: 32,
        height: 32,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Icon fontSize="small" sx={{ height: "0.85em" }} />
    </MuiBox>
  );
};

SectionIcon.propTypes = {
  color: PropTypes.string.isRequired,
  icon: PropTypes.elementType,
};

export default SectionIcon;
